import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  user: {},
  users: [],
  isAuthorised: null
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
